import DatePickerComponent from '@components/inputs/datePicker/DatePicker.component';
import ModalComponent from '@components/modal/Modal.component';
import { Sizes } from '@constants/sizes.constants';
import { Button, Stack } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { finalize, switchMap } from 'rxjs';
import { AuditOfferServiceGroupedActionsDto } from '../../../../store/audits/audit-offer/audit-offer.model';
import { auditsOfferService } from '../../../../store/audits/audit-offer/audit-offer.services';
import AuditsToggleButton from '../components/AuditsToggleButton';

interface GroupedProps {
  startDate: Date;
  endDate: Date;
  canAsk: boolean;
  isRecurrence: boolean;
}

interface GroupModalProps {
  handleCloseModal: () => void;
  selectedProposalRow: number[];
}

const GroupModal = (props: GroupModalProps) => {
  const { handleCloseModal, selectedProposalRow } = props;
  const { t } = useTranslation();
  const { auditId } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const [groupedUpdate, setGroupedUpdate] = useState<Partial<GroupedProps>>({ canAsk: true, isRecurrence: true });
  const isDisabled = false;//!_.every([groupedUpdate?.startDate, groupedUpdate?.endDate], (value) => _.isDate(value) || (!_.isNil(value) && value !== ''));

  const updateGroupe = (name: string) => (value: any) => setGroupedUpdate((state) => ({ ...state, [name]: value }));

  const handleValidate = () => {

    const data: AuditOfferServiceGroupedActionsDto = {
      auditOfferIds: selectedProposalRow,
      validFromDate: groupedUpdate?.startDate as Date,
      validToDate: groupedUpdate?.endDate as Date,
      canBeRequested: groupedUpdate?.canAsk as boolean,
      enableSchedule: groupedUpdate?.isRecurrence as boolean
    };

    auditsOfferService.PATCHServiceGroupedActions(data).pipe(
      finalize(() => handleCloseModal()),
      switchMap(() => auditsOfferService.GETAuditOffersByAudit(auditId as string))
    ).subscribe({
      error: (err) => enqueueSnackbar(err.text, err.options),
      next: () => {
        enqueueSnackbar(t('audits.success.offer.price-group-action'), { variant: 'success' });
        handleCloseModal();
      },
    });
  };


  return (
    <ModalComponent
      aria-label="over-drawer"
      title={t('audits.OfferFormalization.groupedModal.title')}
      handleClose={handleCloseModal}
      customColor='#FFFFFF'
      contentHeight='60vh'
      contentFullWidth
      content={(
        <Stack width="100%" height={'100%'} bgcolor='#F4F6F8' justifyContent='center' alignItems='center' spacing={5}>
          <Stack spacing={3}>
            <DatePickerComponent
              color="secondary"
              label={t('audits.OfferActivation.groupedModal.startDate')}
              labelWidth={Sizes.datePickerWidth}
              placeholder={t('audits.OfferActivation.groupedModal.placeholderDate')}
              value={groupedUpdate?.startDate as Date}
              handleChange={updateGroupe('startDate')} />
            <DatePickerComponent
              color="secondary"
              label={t('audits.OfferActivation.groupedModal.endDate')}
              labelWidth={Sizes.datePickerWidth}
              placeholder={t('audits.OfferActivation.groupedModal.placeholderDate')}
              value={groupedUpdate?.endDate as Date}
              handleChange={updateGroupe('endDate')} />
            <AuditsToggleButton
              label={t('audits.OfferActivation.groupedModal.canAsk')}
              labelWidth={Sizes.datePickerWidth}
              isActive={groupedUpdate?.canAsk as boolean}
              handleToggle={(isActive) => updateGroupe('canAsk')(isActive)}
            />
            <AuditsToggleButton
              label={t('audits.OfferActivation.groupedModal.recurrence')}
              labelWidth={Sizes.datePickerWidth}
              isActive={groupedUpdate?.isRecurrence as boolean}
              handleToggle={(isActive) => updateGroupe('isRecurrence')(isActive)}
            />
          </Stack>
          <Button variant='contained' disabled={isDisabled} onClick={handleValidate}>
            {t('global.validate')}
          </Button>
        </Stack >
      )}
    />
  );
};

export default GroupModal;